export default {
  categories: {
    list_of_categories: 'Liste des catégories',
    topic: 'Sujet',
    topic_code: 'Code du sujet',
    topicCode: 'Code du sujet',
    parentCategory: 'Catégorie parente',
    noParent: 'Aucun parent',
    create_a_new_category: 'Créer une nouvelle catégorie',
    edit_category: 'Modifier la catégorie',
    confirm_remove_category: 'Confirmer la suppression de la catégorie ?',
    categories_management: 'Gestion des catégories',
    search_placeholder: 'Rechercher des catégories...',
    no_results: 'Aucun résultat trouvé',
    no_categories: 'Aucune catégorie trouvée',
    parent: 'Parent',
    confirm_delete: 'Confirmer la suppression',
    delete_success: 'Catégorie supprimée avec succès',
    delete_error: 'Erreur lors de la suppression de la catégorie',
    create_success: 'Catégorie créée avec succès',
    create_error: 'Erreur lors de la création de la catégorie',
    update_success: 'Catégorie mise à jour avec succès',
    update_error: 'Erreur lors de la mise à jour de la catégorie',
    save_error: 'Erreur lors de la sauvegarde de la catégorie',
    add_category: 'Ajouter une catégorie',
    enter_topic: 'Entrer le sujet',
    enter_topic_code: 'Entrer le code du sujet',
    select_parent: 'Sélectionner la catégorie parente',
    no_parent: 'Aucun parent',
    label: 'Libellé',
    label_english: 'Libellé (Anglais)',
    code: 'Code',
    filter: 'Filtre',
    parent_category: 'Catégorie parente',
    edit_universe_category: 'Modifier la catégorie Univers',
    add_universe_category: 'Ajouter une catégorie Univers',
    create_a_new_universe_category: 'Créer une nouvelle catégorie Univers',
    universe_categories_management: 'Gestion des catégories Univers',
    create_a_new_sub_category: 'Créer une nouvelle sous-catégorie',
    subcategories_management: 'Gestion des sous-catégories',
    edit_subcategory: 'Modifier la sous-catégorie',
    create_a_new_subcategory: 'Créer une nouvelle sous-catégorie',
    create: 'Créer',
    select_parent_category: 'Sélectionner la catégorie parente',
    type: 'Type',
    template_preview: 'Aperçu du modèle',
    template_one: 'Modèle Un',
    template_two: 'Modèle Deux',
    template_three: 'Modèle Trois',
    select_category: 'Sélectionner la catégorie',
    one_or_more_categories: 'Une ou plusieurs catégorie(s)',
    import_excel: 'Importer depuis Excel',
    import_template: 'Télécharger le modèle',
    import_loading: 'Import en cours…',
    import_done: 'Import terminé',
    import_universes: 'Univers',
    import_categories: 'Catégories',
    import_subcategories: 'Sous-catégories',
    import_created: 'créés',
    import_existing: 'déjà existants',
    import_errors: "Erreurs détectées, rien n'a été importé",
    import_row: 'Ligne',
    import_select_file: 'Veuillez sélectionner un fichier .xlsx ou .xls',
    import_close: 'Fermer',
  },
};
